import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol viewBox=\"0 0 14 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n  <polyline stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"9 1 13 5.994 9 11\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" />\n  <line x1=\"12.784\" y1=\"6.308\" x2=\"1.286\" y2=\"6.25\" stroke-linecap=\"square\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol